import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Globe2 } from "lucide-react";

export function PublicNav() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[hsl(var(--navy))]/80 border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 text-slate-100" data-testid="brand-home-link">
          <span className="h-8 w-8 rounded-sm bg-[hsl(var(--gold))] flex items-center justify-center text-[hsl(var(--navy))]"><Globe2 size={18}/></span>
          <span className="font-display text-xl tracking-tight">GlobalBuy <span className="text-[hsl(var(--gold))]">AI</span></span>
        </Link>
        <nav className="hidden md:flex items-center gap-7 text-sm text-slate-300">
          <Link to="/#how" className="hover:text-white transition-colors">How it works</Link>
          <Link to="/#workflow" className="hover:text-white transition-colors">Workflow</Link>
          <Link to="/#analytics" className="hover:text-white transition-colors">Analytics</Link>
          <Link to="/pricing" className="hover:text-white transition-colors" data-testid="nav-pricing-link">Pricing</Link>
          <Link to="/#faq" className="hover:text-white transition-colors">FAQ</Link>
        </nav>
        <div className="flex items-center gap-3">
          {user ? (
            <>
              <button onClick={() => nav(`/${user.role}`)} className="btn-ghost-light" data-testid="nav-dashboard-btn">Dashboard</button>
              <button onClick={() => { logout(); nav("/"); }} className="text-slate-300 hover:text-white text-sm" data-testid="nav-logout-btn">Sign out</button>
            </>
          ) : (
            <>
              <Link to="/login" className="text-slate-300 hover:text-white text-sm" data-testid="nav-login-link">Sign in</Link>
              <Link to="/signup" className="btn-gold" data-testid="nav-signup-btn">Get started</Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
